import TrophyWall from "./TrophyWall";
import { FC} from "react";
import styled from "styled-components";

const Trophies: FC = ({}) => {
  return (
    <Container>
      <TrophyWall />
    </Container>
  );
};

export default Trophies;
const Container = styled.div`
  background-color: transparent;
  padding: 2rem;
  height: 100%;
  @media (max-width: 991px) {
    padding: 6rem;
  }
  @media (max-width: 768px) {
    padding: 2rem;
    min-height: 90vh;
  }
  @media (max-width: 576px) {
    padding: 1rem;
  }
  @media (max-width: 350px) {
    padding: 0rem;
  }
  border-radius: 8px;
`;
